import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer as MuiDrawer } from '@mui/material';
import React from 'react';
import { withPaperElevation } from '../paper';
export const Drawer = React.forwardRef((props, ref) => {
    return (_jsx(MuiDrawer, { ref: ref, variant: "persistent", ...props, slotProps: {
            ...props.slotProps,
            paper: withPaperElevation(props.slotProps?.paper, 'L')
        } }));
});
